import { render, staticRenderFns } from "./InfoInput.vue?vue&type=template&id=d0142c2a&scoped=true&lang=pug&"
import script from "./InfoInput.vue?vue&type=script&lang=js&"
export * from "./InfoInput.vue?vue&type=script&lang=js&"
import style0 from "./InfoInput.vue?vue&type=style&index=0&id=d0142c2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0142c2a",
  null
  
)

export default component.exports